import { useEffect, useRef, useState } from "react";
import { RESEND_COOLDOWN_SEC } from "../constants";

/**
 * Countdown timer for OTP resend cooldown.
 * @param {number} [durationSec] - Cooldown length in seconds
 * @returns {{ countdown: number, start: () => void, reset: () => void }}
 */
export function useResendCooldown(durationSec = RESEND_COOLDOWN_SEC) {
	const [countdown, setCountdown] = useState(0);
	const intervalRef = useRef(null);

	useEffect(
		() => () => {
			if (intervalRef.current) clearInterval(intervalRef.current);
		},
		[],
	);

	const start = () => {
		setCountdown(durationSec);
		if (intervalRef.current) clearInterval(intervalRef.current);
		intervalRef.current = setInterval(() => {
			setCountdown((prev) => {
				if (prev <= 1) {
					clearInterval(intervalRef.current);
					return 0;
				}
				return prev - 1;
			});
		}, 1000);
	};

	const reset = () => {
		if (intervalRef.current) clearInterval(intervalRef.current);
		setCountdown(0);
	};

	return { countdown, start, reset };
}
